import { create } from "zustand";

interface SuccessRetryPaymentListenerState {
  inProcessRetryPayment: null | boolean;
  setInProcessRetryPayment: (state: boolean) => void;

  successfulPurchase: boolean;
  setSuccessfulPurchase: (state: boolean) => void;

  showPaymentErrorAlert: boolean;
  setShowPaymentErrorAlert: (state: boolean) => void;

  reset: () => void;
}

const useSuccessRetryPaymentListenerStore =
  create<SuccessRetryPaymentListenerState>((set) => ({
    inProcessRetryPayment: null,
    setInProcessRetryPayment: (inProcessRetryPayment) =>
      set({ inProcessRetryPayment }),

    successfulPurchase: false,
    setSuccessfulPurchase: (successfulPurchase) => set({ successfulPurchase }),

    showPaymentErrorAlert: false,
    setShowPaymentErrorAlert: (showPaymentErrorAlert) =>
      set({ showPaymentErrorAlert }),

    reset: () =>
      set({
        inProcessRetryPayment: null,
        successfulPurchase: false,
        showPaymentErrorAlert: false,
      }),
  }));

export default useSuccessRetryPaymentListenerStore;
